(function (global, factory) {
  if ('function' == typeof define && define.amd) define(['module', 'exports'], factory);else if ('undefined' != typeof exports) factory(module, exports);else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports), global.get_CSRF = mod.exports;
  }
})(this, function (module, exports) {
  'use strict';

  Object.defineProperty(exports, '__esModule', {
    value: !0
  }), exports.default = function () {
    var token = document.querySelector('meta[name=csrf-token]'),
        param = document.querySelector('meta[name=csrf-param]');
    return {
      token: token.content,
      param: param.content
    };
  };
  module.exports = exports['default'];
});